"use strict";

var _classCallCheck = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/gatsby-site/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var _require = require('preact'),
    cloneElement = _require.cloneElement,
    Component = _require.Component,
    toChildArray = _require.toChildArray;

var classNames = require('classnames');

var transitionName = 'uppy-transition-slideDownUp';
var duration = 250;
/**
 * Vertical slide transition.
 *
 * This can take a _single_ child component, which _must_ accept a `className` prop.
 *
 * Currently this is specific to the `uppy-transition-slideDownUp` transition,
 * but it should be simple to extend this for any type of single-element
 * transition by setting the CSS name and duration as props.
 */

var Slide = /*#__PURE__*/function (_Component) {
  _inherits(Slide, _Component);

  var _super = _createSuper(Slide);

  function Slide(props) {
    var _this;

    _classCallCheck(this, Slide);

    _this = _super.call(this, props);
    _this.state = {
      cachedChildren: null,
      className: ''
    };
    return _this;
  } // TODO: refactor to stable lifecycle method
  // eslint-disable-next-line


  _createClass(Slide, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps) {
      var _this2 = this;

      var cachedChildren = this.state.cachedChildren;
      var child = toChildArray(nextProps.children)[0];
      if (cachedChildren === child) return null;
      var patch = {
        cachedChildren: child
      }; // Enter transition

      if (child && !cachedChildren) {
        patch.className = "".concat(transitionName, "-enter");
        cancelAnimationFrame(this.animationFrame);
        clearTimeout(this.leaveTimeout);
        this.leaveTimeout = undefined;
        this.animationFrame = requestAnimationFrame(function () {
          // Force it to render before we add the active class
          // this.base.getBoundingClientRect()
          _this2.setState({
            className: "".concat(transitionName, "-enter ").concat(transitionName, "-enter-active")
          });

          _this2.enterTimeout = setTimeout(function () {
            _this2.setState({
              className: ''
            });
          }, duration);
        });
      } // Leave transition


      if (cachedChildren && !child && this.leaveTimeout === undefined) {
        patch.cachedChildren = cachedChildren;
        patch.className = "".concat(transitionName, "-leave");
        cancelAnimationFrame(this.animationFrame);
        clearTimeout(this.enterTimeout);
        this.enterTimeout = undefined;
        this.animationFrame = requestAnimationFrame(function () {
          _this2.setState({
            className: "".concat(transitionName, "-leave ").concat(transitionName, "-leave-active")
          });

          _this2.leaveTimeout = setTimeout(function () {
            _this2.setState({
              cachedChildren: null,
              className: ''
            });
          }, duration);
        });
      } // eslint-disable-next-line


      this.setState(patch);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          cachedChildren = _this$state.cachedChildren,
          className = _this$state.className;

      if (!cachedChildren) {
        return null;
      }

      return cloneElement(cachedChildren, {
        className: classNames(className, cachedChildren.props.className)
      });
    }
  }]);

  return Slide;
}(Component);

module.exports = Slide;